import { OLMSApiService } from '@/shared/apis'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { upsertMultipleAttributes } from '../attributesSlice'
import { Attribute } from '../models/Attribute'

export const fetchOrderAttributes = createAsyncThunk('orderAttributes/fetch', async (_, { dispatch }) => {
  const orderAttributes = await OLMSApiService.get<Attribute[]>('/list/orderAttributes')

  if (orderAttributes && orderAttributes.length > 0) {
    dispatch(upsertMultipleAttributes(orderAttributes))
  }

  return orderAttributes
})
